// extracted by mini-css-extract-plugin
module.exports = {"container":"_1peXzp2b5RXHLYGqdShT_s","cancelBtn":"_3sUs6K_oJJJFANPP94YaPL","icon":"idkN0b8ryZ7aZtjFj8Oqk","saveBtn":"hVSLdp7w2yZPpW242-rDh"};